import React from "react";
import ConnectedRecurringSummaryHistory from "../../Pages/RecurringSummaryPage/RecurringSummaryHistory";

/**
 * @param {object} props
 * @param {object} props.control
 * @returns {React.JSX.Element}
 */
const RecurringSummaryHistoryControl = ({ control }) => (
    <ConnectedRecurringSummaryHistory control={control} />
);

export default RecurringSummaryHistoryControl;
